import { styled } from '@mui/system';
import { Typography } from '@mui/material';

const EmailNotificationTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: 400,
  color: '#2196F3',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '12px 0px 0px 0px',
});

const ErrorNotificationTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontSize: '12px',
  fontWeight: 400,
  color: '#F44336',
  lineHeight: '24px',
  textAlign: 'left',
  margin: '12px 0px 0px 0px',
});

const AddPadding = styled('div')({
  padding: '0px 12px',
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  marginTop: '12px',
});

export { EmailNotificationTypography, ErrorNotificationTypography, AddPadding };
